import { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";

import { NavBarFinal } from "../components/index";
import { getData } from "../../../api/apiCalls";

const TrackCompany = ({ presenter, i }) => {
   const [content, setContent] = useState(null);

   useEffect(() => {
      presenter.logo_url
         ? setContent(<img
            alt='logo'
            src={presenter.logo_url}
            loading={i < 10 ? "eager" : "lazy"}
            style={{
               width: "200px",
               height: "193px",
               objectFit: "scale-down",
               opacity: "1",
            }}
         />)
         : setContent(
            <h2
               style={{
                  width: "225px",
                  height: "225px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
               }}
            >
               {presenter.company}
            </h2>
         );
   }, [i, presenter]);

   const details = (
      <div>
         <Stack
            spacing={2}
            sx={{
               width: "225px",
               height: "225px",
               position: "relative",
               display: "flex",
               alignItems: "center",
               justifyContent: "center",
               margin: "0 !important",
               padding: "0 !important",
            }}

            onMouseLeave={(e) => {
               presenter.logo_url
                  ? setContent(<img
                     alt='logo'
                     src={presenter.logo_url}
                     loading={i < 10 ? "eager" : "lazy"}
                     style={{
                        width: "200px",
                        height: "193px",
                        objectFit: "scale-down",
                        opacity: "1",
                     }}
                  />)
                  : setContent(
                     <h2
                        style={{
                           width: "225px",
                           height: "225px",
                           display: "flex",
                           alignItems: "center",
                           justifyContent: "center",
                           textAlign: "center",
                        }}
                     >
                        {presenter.company}
                     </h2>
                  );
            }}
         >
            {presenter.logo_url && (
               <img
                  alt='logo'
                  src={presenter.logo_url}
                  loading={i < 10 ? "eager" : "lazy"}
                  style={{
                     width: "200px",
                     height: "100px",
                     objectFit: "scale-down",
                     opacity: ".075",
                  }}
               />
            )}
            <div
               style={{
                  position: "absolute",
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
               }}
            >
               <h5
                  style={{
                     width: "100%",
                     color: "#7C2387",
                     textAlign: "center",
                     fontWeight: 'bold'
                  }}
               >
                  {presenter.company}
               </h5>
               <div style={{ fontSize: ".85rem", marginTop: '2.5vh' }}>{presenter.one_liner}</div>
            </div>
         </Stack>
      </div>
   );


   return (
      <Grid item sx={{ justifyContent: 'center', display: 'flex' }} >
         <Paper
            sx={{
               width: "300px",
               height: "250px",
               display: "flex",
               justifyContent: "center",
               alignItems: "center",

            }}
            onMouseEnter={(e) => {
               setContent(details);
            }}
            elevation={15}
         >
            {content}
         </Paper>
      </Grid>
   );
};

export const Presenters = () => {
   document.title = "Florida Venture Summit | Presenters";

   const [presenters, setPresenters] = useState([]);
   useEffect(() => {
      getData("https://youngstartup.io/api/cwebsite/get_presenting_comp")
         .then((data) => {
            setPresenters(data.all_companies);
         });
   }, []);

   return (
      <div style={{ backgroundColor: "white" }}>
         <NavBarFinal />
         <img alt='presenters-banner' src={Window.innerWidth < 900 ? "./assets/media/Presenters Benner Mobile.png" : "./assets/media/Presenters Banner.png"} style={{ width: '100%' }} />
         <div>
            <Grid
               container
               spacing={3}
               sx={{
                  overflowY: "scroll",
                  alignItems: "stretch",
                  display: "flex",
                  justifyContent: "center",
                  padding: "2.5% 5%",
                  margin: '0%'
               }}
               columns={{ md: 5, lg: 5, xl: 5 }}
            >
               {presenters &&
                  presenters?.map((presenter, i) => {
                     return <TrackCompany key={i} i={i} presenter={presenter} />;
                  })}
            </Grid>
         </div>
      </div>
   );
};
